export const getFirstPageId = (items = []) => {
    for (const item of items) {
        if (item?.type === "page" && item.status == "current") {
            return item.id;
        }
        if (Array.isArray(item?.children) && item.children.length > 0) {
            const nestedPageId = getFirstPageId(item.children);
            if (nestedPageId) {
                return nestedPageId;
            }
        }
    }
    return null;
};
